//  inspiration: https://github.com/yowainwright/scrolldir

import * as React from 'react';
import { getScrollY } from '~/Utils/scrollPosition';

export type ScrollDirection = 'up' | 'down';

export const useScrollDirection = (
    thresholdPixels: number,
    initialDirection: ScrollDirection = 'down',
    elementId?: string,
    off = false
) => {
    const [scrollDirection, setScrollDirection] = React.useState<ScrollDirection>(initialDirection);

    React.useEffect(() => {
        if (off) {
            return;
        }

        const scrollableElement = (elementId && window.document.getElementById(elementId)) || window;
        const threshold = thresholdPixels || 0;
        let lastScrollY = getScrollY(scrollableElement);
        let ticking = false;

        const updateScrollDirection = () => {
            const scrollY = getScrollY(scrollableElement);

            if (Math.abs(scrollY - lastScrollY) < threshold) {
                ticking = false;

                return;
            }

            setScrollDirection(scrollY > lastScrollY ? 'down' : 'up');
            lastScrollY = scrollY > 0 ? scrollY : 0;
            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(updateScrollDirection);
                ticking = true;
            }
        };

        scrollableElement.addEventListener('scroll', onScroll);

        return () => scrollableElement.removeEventListener('scroll', onScroll);
    }, [initialDirection, thresholdPixels, off, elementId]);

    return { scrollDirection };
};
